import { Card } from "@/components/ui/card/Card";

export const TargetAudience = () => {
  return (
    <section className="py-20 bg-section md:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl mb-16 md:mb-20">
          <h2 className="text-3xl md:text-5xl text-text-primary mb-5">
            Built for VAT-registered UK small businesses.
          </h2>
          <p className="text-lg md:text-xl text-text-secondary">
            The same problem across every sector: cash in the bank is not always
            cash available to spend.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          <Card>
            <h3 className="text-xl font-medium mb-4 text-text-primary tracking-[-0.01em]">
              Cleaning companies
            </h3>
            <p className="text-base text-text-secondary leading-[1.6]">
              Weekly invoices, monthly VAT bills, and cash that moves fast.
              Repayas shows what is safe before the money arrives.
            </p>
          </Card>
          <Card>
            <h3 className="text-xl font-medium text-text-primary mb-4 tracking-[-0.01em]">
              Trades and contractors
            </h3>
            <p className="text-base text-text-secondary leading-[1.6]">
              Irregular income, big expenses, and VAT that can pile up. Know
              your real position before each job payment clears.
            </p>
          </Card>
          <Card>
            <h3 className="text-xl font-medium text-text-primary mb-4 tracking-[-0.01em]">
              Agencies and service businesses
            </h3>
            <p className="text-base text-text-secondary leading-[1.6]">
              Long payment terms and lumpy cash flow. Repayas separates client
              money from what you can actually spend.
            </p>
          </Card>
        </div>
      </div>
    </section>
  );
};
